export const setGroupMemberList = (memberList) =>
	({
		type    : 'SET_GROUP_MEMBER_LIST',
		payload : { memberList }
	});
export const setGroupMemberListInProgress = (isProgress) =>
	({
		type    : 'SET_GET_GROUP_LIST_INPROGRESS',
		payload : isProgress
	});

export const setCallReconnecting = (reconnecting) =>
	({
		type    : 'SET_CALL_RECONNECTING',
		payload : reconnecting
	});
export const setCallDetails = (callDetails) =>
	({
		type    : 'SET_CALL_DETAILS',
		payload : callDetails
	});

export const setUserStatus = (statusData) =>
	({
		type    : 'SET_USER_STATUS',
		payload : statusData
	});